import { FormField } from '@amzn/awsui-components-core';
import React, { useContext, useState } from 'react';
import { CodeRepoFormCtx } from './CodeRepoFormContext';
import UserIdAutosuggest from '../../../../common/UserIdAutosuggest';

export const SecurityGuardianFormField = () => {
  // @ts-expect-error TS2339 - strict migration
  const { repoData, onInputValidation, setRepoData } = useContext(CodeRepoFormCtx);

  const handleChange = (
    selectedUserId: string,
    selectedUserName: string,
    selectedUserError: any,
  ) => {
    // @ts-expect-error TS7006 - strict migration
    setRepoData((prevState) => ({ ...prevState, securityGuardian: selectedUserId }));
    onInputValidation('security_guardian', !!selectedUserError);
  };

  return (
    <div className="awsui">
      <FormField
        label={
          <span>
            Security guardian{' '}
            <i>- Once a guardian has reviewed your code repo, select their alias here</i>
          </span>
        }
      >
        <UserIdAutosuggest
          userId={repoData.securityGuardian}
          isRequired={false}
          onUserSelected={handleChange}
        />
      </FormField>
    </div>
  );
};
